module.exports = __webpack_public_path__ + "static/media/Anastasia.png.png.6ef23a88.webp";